/* HolzWurmDesign – Live-Gravur direkt auf dem Produktfoto (v2)
   Pro Produkt ist die Gravurflaeche als Vektor-Zone vermessen (cx/cy/rx/ry
   in % der Bildmasse). Der Text aus den Personalisierungs-Feldern erscheint
   nur INNERHALB dieser Zone, ist frei verschiebbar und skaliert automatisch.
   Produkte ohne vermessene Zone zeigen kein Overlay. */
(function () {
  'use strict';

  /* ---- Vermessene Gravur-Zonen ----
     img: Sicherheits-Anker – Overlay nur, wenn dieses Foto angezeigt wird.
     variants: eigene Zone je Varianten-Wert (z. B. Fisch/Taube).            */
  var ZONES = {
    'taufe-tischdeko': {
      img: 'IMG_1496',
      variants: {
        'Fisch': { cx: 60.8, cy: 63.2, rx: 7.6, ry: 4.6 },
        'Taube': { cx: 35.0, cy: 62.0, rx: 6.0, ry: 4.2 }
      },
      fallback: 'Fisch'
    },
    'namensschild-astscheibe-besonderer-anlass-indiv-gravur': {
      img: 'IMG_1511',
      zone: { cx: 50.0, cy: 68.0, rx: 6.5, ry: 6.9 }
    },
    'hochzeit-tischdeko': {
      img: 'IMG_1524',
      zone: { cx: 47.5, cy: 64.0, rx: 11.0, ry: 6.2 }
    }
  };
  var FONT = "'Segoe Script','Brush Script MT','Comic Sans MS',cursive";
  var SVGNS = 'http://www.w3.org/2000/svg';

  function init() {
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    var CFG = handle && ZONES[handle];
    if (!CFG) return;

    var img = document.querySelector('.product__media-item img, .product__media img');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!img || !form) return;

    var inputs = Array.prototype.slice.call(
      document.querySelectorAll('input[type="text"][name^="properties["], textarea[name^="properties["]')
    );
    if (!inputs.length) return;

    var host = img.closest('.product__media') || img.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var svg = null, R = 100, els = [], drag = null, outline = null;

    function activeZone() {
      if (CFG.zone) return CFG.zone;
      var checked = document.querySelector('.product-form__input input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
      var key = (checked && CFG.variants[checked.value]) ? checked.value : CFG.fallback;
      return CFG.variants[key];
    }
    function imgOk() { return (img.currentSrc || img.src || '').indexOf(CFG.img) > -1; }

    function build() {
      if (svg) { svg.remove(); svg = null; }
      if (!imgOk()) return;
      var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
      R = Math.round(1000 * h / w);
      svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('viewBox', '0 0 1000 ' + R);
      svg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;mix-blend-mode:multiply;z-index:2;';
      var Z = activeZone();
      var zx = Z.cx * 10, zy = Z.cy / 100 * R, zrx = Z.rx * 10, zry = Z.ry / 100 * R;
      var defs = document.createElementNS(SVGNS, 'defs');
      var clip = document.createElementNS(SVGNS, 'clipPath');
      clip.setAttribute('id', 'hwdZoneClip');
      var ce = document.createElementNS(SVGNS, 'ellipse');
      ce.setAttribute('cx', zx); ce.setAttribute('cy', zy);
      ce.setAttribute('rx', zrx); ce.setAttribute('ry', zry);
      clip.appendChild(ce); defs.appendChild(clip); svg.appendChild(defs);
      outline = document.createElementNS(SVGNS, 'ellipse');
      outline.setAttribute('cx', zx); outline.setAttribute('cy', zy);
      outline.setAttribute('rx', zrx); outline.setAttribute('ry', zry);
      outline.setAttribute('fill', 'none');
      outline.setAttribute('stroke', '#B4622D');
      outline.setAttribute('stroke-width', '3');
      outline.setAttribute('stroke-dasharray', '10 8');
      outline.style.opacity = '0';
      outline.style.transition = 'opacity .3s';
      svg.appendChild(outline);
      var g = document.createElementNS(SVGNS, 'g');
      g.setAttribute('clip-path', 'url(#hwdZoneClip)');
      svg.appendChild(g);
      els = [];
      var n = inputs.length;
      inputs.forEach(function (inp, i) {
        var t = document.createElementNS(SVGNS, 'text');
        t.setAttribute('text-anchor', 'middle');
        t.setAttribute('fill', '#4A3115');
        t.setAttribute('opacity', '.92');
        t.style.fontFamily = FONT;
        t.style.pointerEvents = 'auto';
        t.style.cursor = 'grab';
        var fs = (i === 0 ? zry * 0.62 : zry * 0.42);
        var off = n === 1 ? 0 : (i === 0 ? -zry * 0.25 : zry * 0.38 + (i - 1) * zry * 0.42);
        var el = { t: t, x: zx, y: zy + off + fs * 0.35, fs: fs, inp: inp, maxW: zrx * 1.8 };
        t.addEventListener('pointerdown', function (ev) {
          drag = { el: el, sx: ev.clientX, sy: ev.clientY, ox: el.x, oy: el.y };
          t.setPointerCapture(ev.pointerId);
          ev.preventDefault();
        });
        els.push(el); g.appendChild(t);
      });
      svg.addEventListener('pointermove', function (ev) {
        if (!drag) return;
        var box = svg.getBoundingClientRect();
        var k = 1000 / box.width;
        drag.el.x = drag.ox + (ev.clientX - drag.sx) * k;
        drag.el.y = drag.oy + (ev.clientY - drag.sy) * k;
        paintEl(drag.el);
      });
      svg.addEventListener('pointerup', function () { drag = null; });
      host.appendChild(svg);
      paint();
    }

    function paintEl(el) {
      el.t.setAttribute('x', el.x);
      el.t.setAttribute('y', el.y);
      el.t.setAttribute('font-size', el.fs);
      el.t.textContent = el.inp.value.trim();
      /* auto in die Breite einpassen */
      try {
        var len = el.t.getComputedTextLength();
        var f = el.fs;
        while (len > el.maxW && f > el.fs * 0.45) {
          f *= 0.92;
          el.t.setAttribute('font-size', f);
          len = el.t.getComputedTextLength();
        }
      } catch (e) {}
    }
    function paint() { els.forEach(paintEl); }

    function flash() {
      if (!outline) return;
      outline.style.opacity = '1';
      clearTimeout(flash._t);
      flash._t = setTimeout(function () { outline.style.opacity = '0'; }, 1600);
    }

    inputs.forEach(function (inp) {
      inp.addEventListener('input', paint);
      inp.addEventListener('focus', flash);
    });
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches('input[type="radio"]')) {
        setTimeout(function () {
          img = document.querySelector('.product__media-item img, .product__media img') || img;
          build();
        }, 350);
      }
    });
    form.addEventListener('submit', function () {
      var old = form.querySelector('input[name="properties[_Vorschau-Layout]"]');
      if (old) old.remove();
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[_Vorschau-Layout]';
      inp.value = JSON.stringify(els.map(function (el) {
        return { text: el.inp.value, x: Math.round(el.x), y: Math.round(el.y), fs: Math.round(el.fs) };
      }));
      form.appendChild(inp);
    });

    if (img.complete) { build(); } else { img.addEventListener('load', build); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
